// Global smooth scrolling (Lenis): adds wheel/touch smoothing site-wide and
// hooks it into GSAP's ticker + ScrollTrigger. Skipped on the Web Studio landing (own Lenis instance) and reduced-motion.
import { gsap } from 'gsap';
import { ScrollTrigger } from 'gsap/ScrollTrigger';

gsap.registerPlugin(ScrollTrigger);

let lenis = null;

/** Expose the active Lenis instance (used by the anchor smooth-scroll). */
export function getLenis() {
  return lenis;
}

export default function initLenisScroll() {
  if (document.body.classList.contains('web-studio-page')) return;
  if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;
  if (typeof window.Lenis === 'undefined') return;
  if (lenis) return;

  lenis = new window.Lenis({
    duration: 1.1,
    easing: (t) => Math.min(1, 1.001 - Math.pow(2, -10 * t)),
    smoothWheel: true,
  });

  // Share the instance so other modules (anchor scroll) can drive it.
  window.__kdLenis = lenis;

  // Keep ScrollTrigger in step with Lenis' smoothed scroll position.
  lenis.on('scroll', ScrollTrigger.update);

  // Drive Lenis from GSAP's single ticker (one rAF loop for the whole page).
  gsap.ticker.add((time) => {
    lenis.raf(time * 1000);
  });
  gsap.ticker.lagSmoothing(0);
}
